import { Controller } from "stimulus";
import MicroModal from 'micromodal';

export default class extends Controller {
  static targets = ["expandableContainer", 'gradient'];

  connect() {
    MicroModal.init({
      disableScroll: true,
    });
  }

  expandContainer() {
    const expandable = this.expandableContainerTarget
    expandable.classList.toggle('expanded')
    event.currentTarget.classList.toggle('expanded')

    if (expandable.style.maxHeight){
      expandable.style.maxHeight = null;
      expandable.style.height = expandable.style.minHeight
    } else {
      expandable.style.height =  expandable.scrollHeight + "px";
      expandable.style.maxHeight = expandable.scrollHeight + "px";
    }

    this.gradientTarget.classList.toggle('expanded')
  }
}
